module.exports = __webpack_public_path__ + "static/media/objects2_16.59965d3e.svg";